// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
}

.popup-content {
    background-color: #fff;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
    position: relative;
    text-align: left;
    width: 600px;
}

.close {
    position: absolute;
    top: 2px;
    right: 17px;
    cursor: pointer;
    font-size: 25px;
    color: #6b6b6b;
}

.loginForm {
    display: block;
    color: #17213A;
    font-weight: 500px;
    font-size: 18px;
}

.loginInput {
    width: 100%;
    padding: 7px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    margin-bottom: 4%;
}

.form-actions {
    margin-top: 15px !important;
}

.loginHeader {
    color: #17213A;
    font-family: 'Open Sans', sans-serif;
    font-weight: 700;
    position: relative;
    text-align: center !important;
    margin-bottom: 4%;
}

.popupImg {
    position: absolute;
    width: 8%;
    left: 1%;
    top: 10%;
}

.popupTitle {
    position: absolute;
    left: 1%;
}

.selectLoginBtn {
    width: 100% !important;
    background-color: white !important;
    border: none !important;
    font-size: 16px !important;
    margin-top: 3%;
    color: #17213A !important;
}

.selectLoginBtn:hover {
    background-color: white !important;
    color: #4F80FF !important;
}

.loginNow {
    width: 100%;
    border: none !important;
    padding: 1.5%;
    border-radius: 5px;
    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);
    color: white;
    height: 40px;
}

.loginNow:hover {
    width: 100%;
    padding: 1.5%;
    border-radius: 5px;
    /* background-image: url("../images/bg.png"); */
    color: #ffffff;
    border: 1px solid #347571 !important;
}

.errorMsg {
    margin: 0;
    margin-top: 3%;
    color: red;
    font-size: 16px;
}
.msg {
    margin: 0;
    margin-top: 3%;
    color:#35b276;
    font-size: 16px;
}
.loginLabel{
    margin-bottom: 1.5%;
    margin-top: 2%;
}
.jobPopupDescriptionP{
    font-size: 13px;
color: rgb(134, 140, 159);
color: #6b6b6b;
margin: 0;
padding: 0;
}
.jobPopupDescription::placeholder{
    font-size: 10px;
}
.jobTitleInput::placeholder{
    font-size: 14px;
}
.jobInstructionPopup{
    font-size: 16px;
    margin-top: 7% !important;
}
.jobInstructionLowerPopup{
    font-size: 14px;
    margin-bottom: 8%;
    font-style: italic;
}
/* .otpCenterResend{
    text-align: center;
    align-items: center;
} */
.resendOtpBtn{
    background-color: white;
    border: none;
}
.nocodeText{
    display: inline;
}

@media only screen and (max-width: 480px) {
    
    .popupTitle {
        position: relative;
        left: 1%;
    }

    .close {
        top: -20px;
        right: -10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styleSheet/LoginPopup.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,2CAA2C;IAC3C,yFAAyF;IACzF,8IAA8I;IAC9I,2FAA2F;IAC3F,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,sBAAsB;IACtB,kCAAkC;IAClC,uBAAuB;IACvB,0BAA0B;IAC1B,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,kEAAkE;IAClE,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,+CAA+C;IAC/C,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,SAAS;IACT,cAAc;IACd,UAAU;IACV,eAAe;AACnB;AACA;IACI,SAAS;IACT,cAAc;IACd,aAAa;IACb,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,eAAe;AACnB,yBAAyB;AACzB,cAAc;AACd,SAAS;AACT,UAAU;AACV;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;AACA;;;GAGG;AACH;IACI,uBAAuB;IACvB,YAAY;AAChB;AACA;IACI,eAAe;AACnB;;AAEA;;IAEI;QACI,kBAAkB;QAClB,QAAQ;IACZ;;IAEA;QACI,UAAU;QACV,YAAY;IAChB;AACJ","sourcesContent":[".popup {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n}\n\n.popup-content {\n    background-color: #fff;\n    padding: 20px;\n    border-radius: 5px;\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\n    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px;\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;\n    position: relative;\n    text-align: left;\n    width: 600px;\n}\n\n.close {\n    position: absolute;\n    top: 2px;\n    right: 17px;\n    cursor: pointer;\n    font-size: 25px;\n    color: #6b6b6b;\n}\n\n.loginForm {\n    display: block;\n    color: #17213A;\n    font-weight: 500px;\n    font-size: 18px;\n}\n\n.loginInput {\n    width: 100%;\n    padding: 7px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 16px;\n    margin-bottom: 4%;\n}\n\n.form-actions {\n    margin-top: 15px !important;\n}\n\n.loginHeader {\n    color: #17213A;\n    font-family: 'Open Sans', sans-serif;\n    font-weight: 700;\n    position: relative;\n    text-align: center !important;\n    margin-bottom: 4%;\n}\n\n.popupImg {\n    position: absolute;\n    width: 8%;\n    left: 1%;\n    top: 10%;\n}\n\n.popupTitle {\n    position: absolute;\n    left: 1%;\n}\n\n.selectLoginBtn {\n    width: 100% !important;\n    background-color: white !important;\n    border: none !important;\n    font-size: 16px !important;\n    margin-top: 3%;\n    color: #17213A !important;\n}\n\n.selectLoginBtn:hover {\n    background-color: white !important;\n    color: #4F80FF !important;\n}\n\n.loginNow {\n    width: 100%;\n    border: none !important;\n    padding: 1.5%;\n    border-radius: 5px;\n    background-image: linear-gradient(45deg, #4F80FF 0%, #00C6E2 100%);\n    color: white;\n    height: 40px;\n}\n\n.loginNow:hover {\n    width: 100%;\n    padding: 1.5%;\n    border-radius: 5px;\n    /* background-image: url(\"../images/bg.png\"); */\n    color: #ffffff;\n    border: 1px solid #347571 !important;\n}\n\n.errorMsg {\n    margin: 0;\n    margin-top: 3%;\n    color: red;\n    font-size: 16px;\n}\n.msg {\n    margin: 0;\n    margin-top: 3%;\n    color:#35b276;\n    font-size: 16px;\n}\n.loginLabel{\n    margin-bottom: 1.5%;\n    margin-top: 2%;\n}\n.jobPopupDescriptionP{\n    font-size: 13px;\ncolor: rgb(134, 140, 159);\ncolor: #6b6b6b;\nmargin: 0;\npadding: 0;\n}\n.jobPopupDescription::placeholder{\n    font-size: 10px;\n}\n.jobTitleInput::placeholder{\n    font-size: 14px;\n}\n.jobInstructionPopup{\n    font-size: 16px;\n    margin-top: 7% !important;\n}\n.jobInstructionLowerPopup{\n    font-size: 14px;\n    margin-bottom: 8%;\n    font-style: italic;\n}\n/* .otpCenterResend{\n    text-align: center;\n    align-items: center;\n} */\n.resendOtpBtn{\n    background-color: white;\n    border: none;\n}\n.nocodeText{\n    display: inline;\n}\n\n@media only screen and (max-width: 480px) {\n    \n    .popupTitle {\n        position: relative;\n        left: 1%;\n    }\n\n    .close {\n        top: -20px;\n        right: -10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
